/* ODDAY Hero Slider */
if (!customElements.get('odday-hero')) {
  class OddayHero extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('.odh-slide')];
      this.bars = [...this.querySelectorAll('.odh-bar')];
      this.i = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 6000;
      this.auto = this.dataset.autoplay !== 'false' && this.slides.length > 1;
      this.style.setProperty('--odh-speed', this.speed / 1000 + 's');

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.i - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.i + 1));
      this.bars.forEach(b => b.addEventListener('click', () => this.go(+b.dataset.go)));

      let sx = null;
      this.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', e => {
        if (sx === null) return;
        const d = e.changedTouches[0].clientX - sx;
        if (Math.abs(d) > 50) this.go(this.i + (d < 0 ? 1 : -1));
        sx = null;
      });
      this.addEventListener('mouseenter', () => this.pause(true));
      this.addEventListener('mouseleave', () => this.pause(false));
      document.addEventListener('visibilitychange', () => this.pause(document.hidden));

      /* Theme editor: jump to the block being edited */
      document.addEventListener('shopify:block:select', e => {
        const idx = this.slides.findIndex(s => s.contains(e.target) || s === e.target);
        if (idx > -1) { this.go(idx); this.pause(true); }
      });
      document.addEventListener('shopify:block:deselect', () => this.pause(false));

      this.schedule();
    }
    go(n) {
      if (!this.slides.length) return;
      const len = this.slides.length;
      this.slides[this.i].classList.remove('is-active');
      this.bars[this.i]?.classList.remove('is-active');
      this.i = (n + len) % len;
      this.slides[this.i].classList.add('is-active');
      const bar = this.bars[this.i];
      if (bar) { void bar.offsetWidth; bar.classList.add('is-active'); }
      this.schedule();
    }
    schedule() {
      clearTimeout(this.t);
      if (!this.auto || this.paused) return;
      this.started = Date.now();
      this.t = setTimeout(() => this.go(this.i + 1), this.remaining || this.speed);
      this.remaining = 0;
    }
    pause(on) {
      if (!this.auto || on === this.paused) return;
      this.paused = on;
      this.classList.toggle('is-paused', on);
      if (on) { clearTimeout(this.t); this.remaining = Math.max(400, this.speed - (Date.now() - this.started)); }
      else this.schedule();
    }
    disconnectedCallback() { clearTimeout(this.t); }
  }
  customElements.define('odday-hero', OddayHero);
}
